"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductWithInventorySearchResponse = void 0;
const common_1 = require("../../common");
const product_with_inventory_data_response_1 = require("./product-with-inventory-data.response");
class ProductWithInventorySearchResponse extends common_1.PaginatedResponse {
}
exports.ProductWithInventorySearchResponse = ProductWithInventorySearchResponse;
//# sourceMappingURL=product-with-inventory-search.response.js.map